import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover as TinyPopover } from 'react-tiny-popover';
import { useWatchEscapeButton } from '../../hooks/useWatchEscapeButton';
import InfoCircled from '../icons/InfoCircled';
import { _Popover, _PopoverContent, _PopoverIcon } from './_Popover';
export function Popover({ children, i18nextKey }) {
    const { t } = useTranslation();
    const description = t(i18nextKey);
    const hasDescription = Boolean(description) && description !== i18nextKey;
    const [isOpen, setIsOpen] = useState(false);
    const toggleIsOpen = () => setIsOpen(_isOpen => !_isOpen);
    useWatchEscapeButton({
        when: () => isOpen,
        then: () => setIsOpen(false),
    });
    if (!hasDescription) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsxs(_PopoverContent, { children: [children, _jsx(TinyPopover, { isOpen: isOpen, positions: ['right', 'top', 'bottom', 'left'], onClickOutside: toggleIsOpen, padding: 5, content: _jsx(_Popover, { dangerouslySetInnerHTML: { __html: description } }), children: _jsx(_PopoverIcon, { onClick: toggleIsOpen, children: _jsx(InfoCircled, { width: "14", height: "14" }) }) })] }));
}
